import {ScheduleScriptOptionTypeEnum} from 'domain/usecases/private/booking-flow/health/get-questions-schedule-script';
import {normalizeText} from 'presentation/utils/normalizeText';

enum TaggingScheduleScriptEnum {
	SCRIPT = 'script_',
	QUESTION = 'perguntou_',
	RESPONSE = 'respondeu_',
	ACTION = 'click_',
}

const respondedTypes: ScheduleScriptOptionTypeEnum[] = [
	ScheduleScriptOptionTypeEnum.RETRY,
	ScheduleScriptOptionTypeEnum.FLOW,
	ScheduleScriptOptionTypeEnum.CLIENT_RESPONSE,
];

const clickedTypes: ScheduleScriptOptionTypeEnum[] = [
	ScheduleScriptOptionTypeEnum.TELEMEDICINE,
	ScheduleScriptOptionTypeEnum.SCHEDULE,
	ScheduleScriptOptionTypeEnum.CHAT,
];

const DEFAULT_PREFIX = TaggingScheduleScriptEnum.SCRIPT;

function getQuestionDataTagId(question: string): string {
	return `${DEFAULT_PREFIX}${TaggingScheduleScriptEnum.QUESTION}${normalizeText(question)}`;
}

function getOptionDataTagId(optionText: string, type: ScheduleScriptOptionTypeEnum): string {
	if (respondedTypes.includes(type)) {
		return `${DEFAULT_PREFIX}${TaggingScheduleScriptEnum.RESPONSE}${normalizeText(optionText)}`;
	}

	if (clickedTypes.includes(type)) {
		return `${DEFAULT_PREFIX}${TaggingScheduleScriptEnum.ACTION}${normalizeText(optionText)}`;
	}

	return `${DEFAULT_PREFIX}${normalizeText(optionText)}`;
}

export {getQuestionDataTagId, getOptionDataTagId};
